import { handleResponse } from "utils/axios";
import { axiosInstance } from "./index";
import { onGetAllCharge } from "mocksdata/charges";

/*Change Get Api here*/
const getApiCharges = async (query) => {
  onGetAllCharge();
  return axiosInstance({
    method: "get",
    url: "/charges",
    params: query,
  }).then(handleResponse);
};

/*Change Post Api here*/
const postApiCharges = async (data) => {
  return await axiosInstance.post("/charges/admin", data).then(handleResponse);
};

/*Change Put Api here*/
const putApiCharges = async (id, data) => {
  return await axiosInstance.put("/charges/admin", data).then(handleResponse);
};

/*Change Get Api here*/
const deleteApiCharges = async (id, data) => {
  return await axiosInstance.delete("/charges/admin", data).then(handleResponse);
};

const getChargePayments = async (chargeId) => {
  if (!chargeId) {
    return null;
  }
  return await axiosInstance.get(`/charges/code/${chargeId}/payments`).then(handleResponse);
};

export { getApiCharges, postApiCharges, putApiCharges, deleteApiCharges, getChargePayments };
